import * as React from 'react';
import { useEffect, useState } from 'react';
import ChatInterface from '../ChatInterface';
import type { ChatbotProps } from '../../types';
import './Chatbot.scss';

// Inner component that uses auth context
const ChatbotInner: React.FC<ChatbotProps> = ({ 
  mode = 'standalone',
  enableMockMode = false,
  onMinimize,
  ...props 
}) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Handle minimize state changes and notify parent
  const handleMinimize = (minimized: boolean) => {
    setIsMinimized(minimized);
    onMinimize?.(minimized);
  };

  const widgetClasses = mode === 'widget' 
    ? `chatbot chatbot--widget ${isMinimized ? 'minimized' : ''}` 
    : 'chatbot chatbot--standalone';

  // Widget mode specific state
  useEffect(() => {
    if (mode === 'widget') {
      // Add widget styles to body
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [mode]);

  // For widget mode, let ChatbotLauncher handle minimize state
  // Remove the internal minimize button rendering

  if (mode === 'widget' && !isVisible) {
    return null;
  }

  return (
    <div className={widgetClasses}>
      <ChatInterface 
        mode={mode}
        enableMockMode={enableMockMode}
        setIsVisible={setIsVisible}
        {...(mode === 'widget' ? { setIsMinimized: handleMinimize } : {})}
        {...props}
      />
    </div>
  );
};

const Chatbot: React.FC<ChatbotProps> = (props) => {
  return <ChatbotInner {...props} />;
};

export default Chatbot;
